import firebaseService from '../../../firebase/firebaseService';
import useKlydoMutation, {
  UseKlydoMutationOptions,
} from '../../../hooks/useKlydoMutation';

const useUpdateClockApplicationMutation = (
  options?: UseKlydoMutationOptions<string, { clockId: string }>,
) => {
  return useKlydoMutation({
    mutationKey: ['update-clock-application'],
    mutationFn: ({ clockId }) => firebaseService.writeUpdateAppCommand(clockId),
    ...options,
  });
};

export default useUpdateClockApplicationMutation;
